import styled from 'styled-components';

import { Flexbox, Typography } from '@seuk/design-system/atoms';

import { Section } from '../marketing';

export const FormSection = styled(Section)`
  ${({ theme }) => theme.breakpoints.up('md')} {
    padding: ${({ theme }) => theme.spacing(10)} 0;
  }
`;

export const FormPageTitle = styled(Typography).attrs({
  variant: 'h2',
})`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacing(8)};
`;

export const FormParagraph = styled(Typography).attrs({
  component: 'p',
  variant: 'basic',
})`
  margin: ${({ theme }) => theme.spacing(4)} 0;
`;

export const Form = styled(Flexbox)`
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(6)};
`;

export const sendRequest = async <T,>(url, { arg }: { arg: T }) => {
  await fetch(url, {
    method: 'POST',
    body: JSON.stringify(arg),
  }).then(function (response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  });
};
